import React from "react";
import ModalToChange from "../../Layout/ModalToChange";
import StatusJobsForm from "./StatusJobsForm";
import { Button1, SelectForm } from "../../common/Buttons";
class StatusesEditModal extends React.Component {
  constructor() {
    super();
    this.state = {
      id: null,
      id_status: "",
      title: "",
      identifier: "",
      errorBlock: [],
      validateError: true,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const item = nextProps.objectData;
    this.setState({
      id: item.id,
      id_status: item.id_status,
      title: item.title,
      identifier: item.identifier,
      errorBlock: [],
    });
  }

  addStatusJob = () => {
    const customId = Math.floor(Math.random() * 100);
    const variables = {
      id: customId,
      title: "",
      klass_name: "",
      identifier: "",
      show_id: this.state.id,
      start_at: new Date(),
      end_at: new Date(),
    };
    this.props.addStatusJob(variables);
  };

  updateStatusJob = (object) => {
    if (object.created_at) {
      object.show_id = this.state.id;
    }
    this.props.updateStatusJob(object).then((response) => {
      let errorArray = this.state.errorBlock;
      const findIndex = errorArray.findIndex((find) => find.id == object.id);
      if (response.error) {
        if (findIndex == -1) {
          errorArray.push({
            id: object.id,
            errors: response.data,
          });
          this.setState({
            errorBlock: errorArray,
            validateError: !this.state.validateError,
          });
        } else {
          errorArray[findIndex] = {
            id: object.id,
            errors: response.data,
          };
          this.setState({
            errorBlock: errorArray,
            validateError: !this.state.validateError,
          });
        }
      } else {
        if (findIndex !== -1) {
          errorArray.splice(findIndex, 1);
          this.setState({
            errorBlock: errorArray,
            validateError: !this.state.validateError,
          });
        }
      }
    });
  };

  removeStatusJob = (ID, object) => {
    let removeAlert = confirm("Are you sure you want to delete?");
    if (removeAlert) {
      object.show_id = this.state.id;
      this.props.removeStatusJob(ID, object);
    }
  };

  onChangeValue = (e, index) => {
    let status_jobs = [...this.props.status_jobs];
    status_jobs[index][e.target.name] = e.target.value;
    this.props.changeStatusJob(status_jobs);
  };

  render() {
    return (
      <ModalToChange
        handleSave={() => document.getElementById("modalClose").click()}
        status="tableEdit"
        text={"Statusas"}
        buttonText={"Close"}
      >
        <div className="d-flex justify-content-between font-weight-bold mb-2">
          <div>Title</div>
          <div>{this.state.title}</div>
        </div>
        <div className="d-flex justify-content-between font-weight-bold mb-2">
          <div>Status ID</div>
          <div>{this.state.id_status}</div>
        </div>
        <div className="d-flex justify-content-between font-weight-bold mb-2">
          <div>Identifier</div>
          <div
            style={{
              width: 200,
            }}
          >
            <SelectForm
              options={[
                {
                  value: "",
                  label: "None",
                },
                {
                  value: "new",
                  label: "NEW",
                },
                {
                  value: "in_progress",
                  label: "In progress",
                },
                {
                  value: "finished",
                  label: "Finished",
                },
                {
                  value: "canceled",
                  label: "Canceled",
                },
              ]}
              value={this.state.identifier}
              onChange={(identifier) => {
                this.props.updateStatusIdentifier(this.state.id, identifier);
                this.setState({
                  identifier,
                });
              }}
            />
          </div>
        </div>
        {this.props.status_jobs.length !== 0 && (
          <>
            <br />
            <hr />
          </>
        )}
        {this.props.status_jobs.map((item, index) => (
          <StatusJobsForm
            key={item.id}
            status={item}
            index={index}
            errorBlock={this.state.errorBlock}
            validateError={this.state.validateError}
            onChangeValue={this.onChangeValue}
            updateStatusJob={this.updateStatusJob}
            removeStatusJob={this.removeStatusJob}
          />
        ))}
        <div className="d-flex justify-content-center align-items-center mt-2">
          <Button1
            text={"Add"}
            option="plus"
            onClick={() => this.addStatusJob()}
          />
        </div>
      </ModalToChange>
    );
  }
}

export default StatusesEditModal;
